export function Brand() {
  return (
    <span className="brand" aria-label="Krosspaths">
      <span className="brand-mark" aria-hidden="true" />
      <span>Krosspaths</span>
    </span>
  );
}
